import React, { FC, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';

import { Form } from 'antd';

// Shared UI Library Components
import { CustomIcon, EIconName, SwitchElement, CustomTooltip } from '@ppmcore/seven-ppm-core-shared-components-react';

// Styles
import './notification-settings.scss';

// Store entities
import { getUserState } from '../../../../store/user/user.selectors';
import { getUserNotificationSettings, notificationSettingsUpdate } from '../../../../store/user/user.thunks';

// Models
import { INotificationSettings } from '../../../../interfaces/user.interfaces';

type TFormValue = {
  // in_app_notification: boolean,
  email_notification: boolean,
  // sms_notification: boolean,
}

type TNotificationSettingsProps = {};

export const NotificationSettings: FC<TNotificationSettingsProps> = (
  {}: TNotificationSettingsProps
) => {
  const [form] = Form.useForm<TFormValue>();

  const { settings } = useSelector(getUserState);

  const dispatch = useDispatch<any>();

  const saveChanges = (newSettings: INotificationSettings): void => {
    dispatch(notificationSettingsUpdate(newSettings));
  }

  const onValuesChange = (
    _: { [key in keyof TFormValue]: boolean },
    allValues: { [key in keyof TFormValue]: boolean }
  ): void => {
    saveChanges(allValues);
  };

  useEffect(() => {
    form.setFieldsValue({
      // in_app_notification: settings?.in_app_notification,
      email_notification: settings?.email_notification,
    })
  }, [settings])

  useEffect(() => {
    dispatch(getUserNotificationSettings());
  }, [])

  return (
    <div className="notification-settings">
      <div className="notification-settings--header">
        <div className="header-title">
          Notification Settings
        </div>
      </div>
      {/*<div className="notification-settings--description"></div>*/}

      <Form className="notification-settings--body"
            form={ form }
            onValuesChange={ onValuesChange }>
        {/*<div className="body-item">*/}
        {/*  In App Notifications <CustomTooltip title={ 'In App Notifications' }><CustomIcon size={ 'size-md' }*/}
        {/*                                                                           name={ EIconName.Info }/></CustomTooltip>*/}
        {/*  <Form.Item name="in_app_notification" initialValue={ settings?.in_app_notification } valuePropName="checked">*/}
        {/*    <SwitchElement/>*/}
        {/*  </Form.Item>*/}
        {/*</div>*/}

        <div className="body-item">
          Email Notifications <CustomTooltip title={ 'Email Notifications' }><CustomIcon size={ 'size-md' }
                                                                                    name={ EIconName.Info }/></CustomTooltip>
          <Form.Item name="email_notification" initialValue={ settings?.email_notification } valuePropName="checked">
            <SwitchElement/>
          </Form.Item>
        </div>

        {/*<div className="body-item">*/ }
        {/*  SMS Notifications <CustomTooltip title={ 'SMS Notifications' }><CustomIcon size={ 'size-md' }
                                                                                    name={ EIconName.Info }/></CustomTooltip>*/ }
        {/*  <Form.Item name="sms_notification" initialValue={ settings?.sms_notification } valuePropName="checked">*/ }
        {/*    <SwitchElement/>*/ }
        {/*  </Form.Item>*/ }
        {/*</div>*/ }
      </Form>
    </div>
  );
}
